/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_9233b368{background:blue}\n"}]);
export const dummy = "dummy_9233b368";